export default __webpack_public_path__ + "static/media/logo-ing.d6ac0c3b.png";